import React from "react";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useSelector, useDispatch } from "react-redux";
import { hideSnackbar } from "../state/actions-creators";

const CheckResponse = ({ handleClose }) => {
    const response = useSelector((state) => state.response);
    const Alert = (props) => {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    };

    if (response === 200) {
        /* On stop events display successful reseting event */
        return (
            <Alert onClose={handleClose} severity="success">
                All assets reseted successfully!
            </Alert>
        );
    } else if (response === 204) {
        /* On start events do nothing */
        return <div></div>;
    } else {
        return (
            <Alert onClose={handleClose} severity="error">
                Reseting failed! Error: {response}
            </Alert>
        );
    }
};

const SnackbarAlert = () => {
    const { snackbar, response } = useSelector((state) => state);
    const dispatch = useDispatch();
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        dispatch(hideSnackbar());
    };

    return (
        <>
            <Snackbar
                open={snackbar}
                autoHideDuration={8000}
                onClose={handleClose}
                key={response}
            >
                <CheckResponse handleClose={handleClose} />
            </Snackbar>
        </>
    );
};

export default SnackbarAlert;
